<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/parameter-monitorings"
          ></back-button>
          Add Parameter Monitoring
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/parameter-monitorings`"
              >Parameter Monitoring</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="requisition-tab"
                  data-bs-toggle="tab"
                  href="#requisition"
                  role="tab"
                  aria-controls="requisition"
                  aria-selected="true"
                  >Parameter Monitoring</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="peremeterSetDetial-tab"
                  data-bs-toggle="tab"
                  href="#peremeterSetDetial"
                  role="tab"
                  aria-controls="peremeterSetDetial"
                  aria-selected="false"
                  >Parameter Monitoring Details</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For Parameter Monitoring Sectiion -->
              <div
                class="tab-pane fade show active"
                id="requisition"
                role="tabpanel"
                aria-labelledby="requisition-tab"
              >
                <h4>Parameter Monitoring</h4>
                <hr />
                <parameter-monitoring :form="form"></parameter-monitoring>
              </div>
              <!-- For Requsition Details -->
              <div
                class="tab-pane fade"
                id="peremeterSetDetial"
                role="tabpanel"
                aria-labelledby="peremeterSetDetial-tab"
              >
                <h4>Parameter Monitoring Details</h4>
                <hr />
                <parameter-monitoring-detail-form
                  :form="form"
                ></parameter-monitoring-detail-form>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import ParameterMonitoring from "./parameter-monitoring-form.vue";
import ParameterMonitoringDetailForm from "./parameter-monitoring-detail-form.vue";
export default {
  components: { ParameterMonitoring, ParameterMonitoringDetailForm },
  name: "ParameterMonitoringCreate",
  data() {
    return {
      form: {
        parameter_setup_id: "",

        parameter_monitoring_details: [
          {
            parameter_setup_id: "",
            parameter_setup_detail_id: "",
          },
        ],
      },
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;

        this.crew = await axios.post("/parameter_monitorings", this.form);
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/planned-maintenance/parameter-monitorings");
      } catch (e) {
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
